import React from "react";
import { Reveal } from "@/components/Reveal";
import { useI18n } from "@/i18n";

export function HowItWorks() {
  const { t } = useI18n();
  const h = t.how;
  return (
    <section id="how" className="bg-secondary py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <Reveal>
          <p className="overline text-accent">{h.overline}</p>
          <h2 className="mt-4 font-serif text-4xl md:text-6xl tracking-tight leading-[1.02]">{h.title}</h2>
        </Reveal>

        <div className="mt-16 space-y-px">
          {h.steps.map((s, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <div
                className="group grid md:grid-cols-12 gap-6 md:gap-10 items-start py-12 border-t border-border"
                data-testid={`how-step-${i + 1}`}
              >
                <div className="md:col-span-3">
                  <span className="font-serif text-7xl md:text-8xl text-accent/30 group-hover:text-accent transition-colors duration-500">
                    0{i + 1}
                  </span>
                </div>
                <div className="md:col-span-9 md:pt-4">
                  <h3 className="font-serif text-3xl md:text-4xl tracking-tight">{s.t}</h3>
                  <p className="mt-4 max-w-2xl text-muted-foreground text-base md:text-lg leading-relaxed">{s.d}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-10 flex items-center gap-4 rounded-full bg-midnight px-8 py-5" data-testid="how-note">
            <span className="h-2 w-2 rounded-full bg-gold shrink-0" />
            <span className="font-serif text-xl md:text-2xl text-cream">{h.note}</span>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
